import { render } from "./SelectEsporteComponent.vue?vue&type=template&id=4fe00d84&scoped=true"
import script from "./SelectEsporteComponent.vue?vue&type=script&lang=js"
export * from "./SelectEsporteComponent.vue?vue&type=script&lang=js"

import "./SelectEsporteComponent.vue?vue&type=style&index=0&id=4fe00d84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe00d84"]])

export default __exports__